<template>
  <vg-card>
    <div class="container" @click="submitApplication(value)">
      <div class="status" :class="{red: isRed(value.passCardStatus)}">
        {{ value.passCardStatus | enumText(passCardStatus) }}
      </div>
      <vg-view-field-list class="no-hr">
        <vg-view-field label="申请编码:"
                       :value="value.applicationCode"/>
        <vg-view-field label="申请项目:"
                       :value="value.applicationProjectName"/>
        <vg-view-field v-if="value.passCardType === 'TENANT_EMPLOYEE'"
                       label="租户名称:"
                       :value="value.tenantName"/>
        <vg-view-field v-else
                       label="施工位置:"
                       :value="value.constructionLocation"/>
        <vg-view-field label="证件类型:"
                       :value="value.passCardType | enumText(passCardType)"/>
      </vg-view-field-list>
      <div class="right">
        <vg-arrow-icon/>
      </div>
    </div>
    <vg-button-group class="right top-border"
                     v-if="value.passCardStatus === 'REJECTED' || value.passCardStatus === 'PENDING_PAYMENT'">
      <vg-button class="primary small"
                 v-if="value.passCardStatus === 'REJECTED'"
                 @click="reapply(value)">再次申请
      </vg-button>
      <vg-button class="primary small"
                 v-if="value.passCardStatus === 'PENDING_PAYMENT'"
                 @click="continueToPay(value)">继续支付
      </vg-button>
    </vg-button-group>
  </vg-card>
</template>

<script>
import VgButtonGroup from "@/components/Commons/VgButtonGroup.vue";
import VgButton from "@/components/Commons/VgButton.vue";
import VgViewField from "@/components/Commons/VgViewField.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import VgCard from "@/components/Commons/VgCard.vue";
import {VgArrowIcon} from "@/components/Icons";
import passCardStatus from "../../domain/pass-card-status";
import passCardType from "@/domain/pass-card-type";
import {client} from "@/libraries/http";

export default {
  name: "DigitalPassApplication",
  components: {VgArrowIcon, VgCard, VgViewFieldList, VgViewField, VgButton, VgButtonGroup},
  props: {
    value: null
  },
  data() {
    return {
      passCardType,
      passCardStatus
    }
  },
  filters: {},
  methods: {
    isRed(passCardStatus) {
      return passCardStatus === 'REJECTED' || passCardStatus === 'PENDING_PAYMENT'
    },
    //查看详情
    submitApplication(item) {
      //进入记录详情
      this.$router.push({
        path: `/digital-passes/applications/${item.applicationSituationId}`
      });
    },
    //再次申请
    reapply(item) {
      this.$router.push({
        path: `/digital-passes/applications/${item.applicationSituationId}/form`
      });
    },
    refresh(application) {
      if (application?.orderCode) {
        return Promise.resolve(application)
      }

      return client.get(`/api/h5/digital-passes/applications/${application.applicationSituationId}`)
          .then(rsp => {
            const application = rsp.data;
            if (!application?.orderCode) {
              this.$toast.fail("获取工本费失败，请联系相关营运人员")
              return Promise.reject()
            }
            return application
          })
    },
    //继续支付
    continueToPay(item) {
      this.refresh(item)
          .then(application => {
            this.$router.push({
              path: '/scanVerify/chargePay', query: {
                orderNo: application.orderCode,
                orderAmount: application.paymentAmount
              }
            });
          })
    },
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.container .right {
  padding-right: 10px;
}

.card {
  position: relative;
}

.status {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #4BA9F6;
}

.status.red {
  color: #FF3434;
}
</style>
